module.exports = __webpack_public_path__ + "img/16.e45a62c4.jpg";